import {
  FETCH_PRICES_PENDING,
  FETCH_PRICES_SUCCESS,
  FETCH_PRICES_FAILURE
} from '../actions/pricesActions';

const initialState = {
  prices: {},
  loading: {},
  error: {},
};

export default function pricesReducer(state = initialState, action) {
  switch (action.type) {
  case FETCH_PRICES_PENDING:
    return {
      ...state,
      loading: {
        ...state.loading,
        [action.payload.serviceName]: true,
      },
      error: {
        ...state.error,
        [action.payload.serviceName]: null,
      }
    };

  case FETCH_PRICES_SUCCESS:
    return {
      ...state,
      loading: {
        ...state.loading,
        [action.payload.serviceName]: false,
      },
      prices: {
        ...state.prices,
        [action.payload.serviceName]: action.payload.data,
      },
    };

  case FETCH_PRICES_FAILURE:
    return {
      ...state,
      loading: {
        ...state.loading,
        [action.payload.serviceName]: false,
      },
      error: {
        ...state.error,
        [action.payload.serviceName]: action.payload.error,
      },
    };

  default:
    return state;
  }
}
